import React, { ButtonHTMLAttributes } from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { Container } from './styles';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  background: string;
  color: string;
  effect?: boolean;
  loading?: boolean;
}

export const Button: React.FC<ButtonProps> = ({ children, loading, ...props }) => (
  <Container {...props} loading={loading} disabled={loading || undefined}>
    {children}
    {loading && <AiOutlineLoading3Quarters className="ml-2" size={20} />}
  </Container>
);
